//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    maxLines: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      isExpanded: false,
      needsTruncation: false,
      resizeObserver: null
    }
  },
  mounted () {
    this.checkTruncation()
    this.initResizeObserver()
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
  methods: {
    initResizeObserver: function () {
      const $textCell = this.$refs.textCell
      if ($textCell) {
        this.resizeObserver = new ResizeObserver(() => {
          this.checkTruncation()
        })
        this.resizeObserver.observe($textCell)
      }
    },
    toggleExpand: function () {
      this.isExpanded = !this.isExpanded
    },
    checkTruncation: function () {
      const $textCell = this.$refs.textCell
      if ($textCell) {
        const lineHeight = parseFloat(getComputedStyle($textCell).lineHeight)
        const maxHeight = lineHeight * this.maxLines
        this.needsTruncation = $textCell.scrollHeight > maxHeight
      }
    }
  }
}
